import runPdfJob from './runPdfJob';

// Splits the uploaded PDF into one file per page. Resolves to { numberOfPages },
// or null when it fails.
const processPDF = async (key) => {
  try {
    const result = await runPdfJob({
      key,
      startPath: '/process-start',
      resultPath: '/process-result',
      timeout: 10 * 60 * 1000,
      label: 'processing',
    });

    return result;
  } catch (err) {
    console.log(err);
  }

  return null;
};

export default processPDF;
